import { useEffect } from "react";
import { message } from "antd";
import { useDispatch } from "react-redux";
import { Action } from "redux-saga";

import { useComment } from "../../../../store/comment";
import { getMessageInError } from "../../../../hooks/fetch";
import {
    commentList,
    commentListClear,
    commentListErrorClear,
    CommentListParams,
} from "../../../../store/comment/list";

export const useCommentList = () => {
    const dispatch = useDispatch();
    const { list } = useComment();

    const getComments = (params: CommentListParams) => {
        dispatch(commentList(params) as Action)
    }

    useEffect(() => () => {
        dispatch(commentListClear() as Action)
        dispatch(commentListErrorClear() as Action)
    }, [])

    useEffect(() => {
        if (list.error) {
            message
                .error(getMessageInError(list.error))
                .then(() => dispatch(commentListErrorClear() as Action));
        }
    }, [list.error])

    const clearReasponse = () => {
        dispatch(commentListClear() as Action)
        dispatch(commentListErrorClear() as Action)
    }

    return { getComments, list, clearReasponse };
}
